
export default {
  name: 'VehicleSelectorButton',
  props: {
    variant: {
      type: String,
      default: 'inline',
      validator: v => ['inline', 'block'].includes(v),
    },
  },
  computed: {
    selectedVehicle() {
      return this.$store.getters.selected_vehicle
    },
    vehiclePageLink() {
      if (!this.selectedVehicle) return null
      return this.localePath({
        name: 'recherche-led-accessoires-brand-type-typeid',
        params: {
          brand: this.$slugify(this.selectedVehicle.brand.name).toLowerCase(),
          type: this.$slugify(this.selectedVehicle.name).toLowerCase(),
          typeid: this.selectedVehicle.id,
        },
      })
    },
  },
}
